import { ASBIS_ENABLED, GAUSIUM_ENABLED } from './constants'

/** Matches main_vendor / Robot.vendor choices (see API migrations). */
export const VENDOR = {
  AUTONOMICS: 'AUTONOMICS',
  GAUSIUM: 'GAUSIUM',
  ASBIS: 'ASBIS',
} as const

export type VendorCode = typeof VENDOR[keyof typeof VENDOR]

const VENDOR_DISPLAY: Record<string, string> = {
  [VENDOR.AUTONOMICS]: 'Autonomics',
  [VENDOR.GAUSIUM]: 'Gausium',
  [VENDOR.ASBIS]: 'Asbis',
}

/**
 * Human-readable vendor label for UI (filters, etc.). Falls back to a softened code if unknown.
 */
export function getVendorDisplayName(code: VendorCode | string): string {
  if (VENDOR_DISPLAY[code]) return VENDOR_DISPLAY[code]
  if (!code) return ''
  return code
    .split('_')
    .map(part => part.charAt(0) + part.slice(1).toLowerCase())
    .join(' ')
}

/** Hide vendors whose feature flags are off (list / map / facility robots). */
export function isRobotVendorVisible(vendor: string | null | undefined): boolean {
  if (vendor === VENDOR.GAUSIUM) return GAUSIUM_ENABLED
  if (vendor === VENDOR.ASBIS) return ASBIS_ENABLED
  return true
}

export function filterRobotsByEnabledVendors<T extends { vendor?: string | null }>(robots: T[]): T[] {
  return robots.filter(r => isRobotVendorVisible(r.vendor))
}
